import { SocialError } from "../../core/models/common";
import { globalActions } from "./index";
import { login } from "./authorizeActions";
import { UserService } from "../../api/services/users";
import { AuthorizeService } from "../../api/services/authorize";

export const dbLogin = (email: string, password: string, session_token: string) => {
  return (dispatch: any, getState: any) => {
    return AuthorizeService.getInstance().login(email, password, null, null, session_token).then(
      (result: any) => {
        dispatch(login(result));
        // dispatch(push("/home"));
      },
      (error: SocialError) => {
        dispatch(globalActions.showMessage(error.code));
      }
    );
  };
};


export const updatePassword = (userId: number, payload: any) => {
  return (dispatch: any) => {
    return UserService.getInstance()
      .updateUserPassword(userId, payload)
      .then((result: any) => {
        dispatch(globalActions.showMessage(result.message));
        return Promise.resolve(result);
      })
      .catch((err: any) => {
        dispatch(globalActions.showMessage(err.data));
      });
  };
};
